/**
 * Action type constants for the V2 dependent-exclusion store module.
 *
 * Names are intentionally distinct from the V1 action types in
 * ./types.js to avoid collisions in the global Vuex action registry.
 * Both modules can be registered side-by-side without overwriting
 * each other.
 */

export const POST_V2_DEPENDENTS_EXCLUSION =
  'individualExclusion/POST_V2_DEPENDENTS_EXCLUSION';
export const FETCH_V2_DEPENDENTS_EXCLUSION_OF_TICKET =
  'individualExclusion/FETCH_V2_DEPENDENTS_EXCLUSION_OF_TICKET';
export const FETCH_V2_EMPLOYEE_ACTIVE_COVERAGES_WITH_DEPENDENTS =
  'individualExclusion/FETCH_V2_EMPLOYEE_ACTIVE_COVERAGES_WITH_DEPENDENTS';
export const POST_V2_SEND_TO_INSURANCE_DEPENDENTS_EXCLUSION =
  'individualExclusion/POST_V2_SEND_TO_INSURANCE_DEPENDENTS_EXCLUSION';
export const POST_V2_FINISH_DEPENDENTS_EXCLUSION =
  'individualExclusion/POST_V2_FINISH_DEPENDENTS_EXCLUSION';
export const POST_V2_CANCEL_DEPENDENTS_EXCLUSION =
  'individualExclusion/POST_V2_CANCEL_DEPENDENTS_EXCLUSION';
